// extracted by mini-css-extract-plugin
export var noProducts = "SupplierCatalog-module--noProducts--38xX6";